import React from 'react';
import Navbar from './components/Navbar';
import HeroBanner from './components/HeroBanner';
import ProductCard from './components/ProductCard';
import Footer from './components/Footer';
import './App.css';

// Datos de ejemplo para los productos
const products = [
  {
    id: 1,
    name: 'Vestido de verano',
    price: 35.99,
    image: 'https://i.pinimg.com/originals/ca/48/0b/ca480bda130183bd1fb96fae5ed50e82.jpg',
  },
  {
    id: 2,
    name: 'Chaqueta de cuero',
    price: 89.99,
    image: 'https://media.falabella.com/falabellaPE/133265376_01/w=1500,h=1500,fit=pad',
  },
  {
    id: 3,
    name: 'Pantalón vaquero',
    price: 45.50,
    image: 'https://upload.wikimedia.org/wikipedia/commons/d/d2/Jeans_for_men.jpg',
  },
  {
    id: 4,
    name: 'Camiseta básica',
    price: 19.99,
    image: 'https://tommyperu.vtexassets.com/arquivos/ids/276991-800-auto?v=637692740966170000&width=800&height=auto&aspect=true',
  },
];

function App() {
  return (
    <div className="App">
      <Navbar />
      <HeroBanner />
      <div className="products-container">
        {products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
      <Footer />
    </div>
  );
}

export default App;